import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Select } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import styled from 'styled-components'
import ProgramPlan from '../../../components/membership/membership'
import BillingSelection from './billingSelection'
// import ProgramPlanV2 from '../../../components/membership/V2/membership'
// import ProgramPlanV1 from '../../../components/membership/v1/membership'
// import PageLoading from '../../../components/UI/status/loading'

import { loadUser, saveUser } from '../../../utils/storage'
// import { logOut as logOutAction } from '../../../api/people'
import { getMembershipFees, editClient } from '../../../api/team'

import { OnBoardingContainer, OnboardingHeader } from '../style'
import Successful from '../questionnaire/successful'
import { Tabs } from 'antd'
import AppleMembership from '../../../components/membership/AppleMembership'
import PaymentMethodSelection from './paymentMethodSelection'
const { TabPane } = Tabs

const description = (
  <>
    Thank you for joining Apeiron Life. We are excited <br /> to welcome you as
    a new member! <br /> <br />
    Your next step is to fill out our pre-assessment <br /> medical review. Once
    your medical clearance is completed, your Apeiron Life Concierge will <br />
    reach out to begin scheduling.
  </>
)

export default function MembershipSelection(props) {
  const { history } = props
  const user = loadUser()
  const [billingPreference, setBillingPreference] = useState('annually')
  const [type, setType] = useState(user.profile.membership)
  const [isChecked, setIsChecked] = useState(true)
  const [confirming, setConfirming] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [version, setVersion] = useState(3)
  const [amount, setAmount] = useState(null)
  const [loading, setLoading] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState('bank')

  const confirmAble =
    billingPreference &&
    ['evaluation2', 'gold', 'silver', 'bronze', 'remote', 'remote lite', 'insights', 'Condition Assessment', 'Fitness Assessment', 'insights+'].find(
      (item) => item === type
    ) &&
    isChecked

  return (
    <OnBoardingContainer>
      <div className="main-container">
        <OnboardingHeader />
        {showSuccess ? (
          <Successful
            description={description}
            renderBtn={() => (
              <>
                <Button
                  style={{ width: 229 }}
                  size="large"
                  type="primary"
                  onClick={() => history.push('/onboarding/ready')}
                >
                  DO IT NOW
                </Button>
                {/* <br /> */}
                {/* <Button
                  style={{ width: 229, padding: 0, marginTop: 16 }}
                  size="large"
                  type="primary"
                  ghost
                  onClick={logOut}
                >
                  I WILL COME BACK LATER
                </Button> */}
              </>
            )}
          />
        ) : (
          <>
            <MemberShip
              handleMembership={handleMembership}
              handleBillingPreference={handleBillingPreference}
              user={user}
              setVersion={setVersion}
              version={version}
              setAmount={setAmount}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
            />
            <div
              className={version === 3 ? 'footer-text' : ''}
              style={{ padding: version === 3 ? '32px 125px' : '32px 205px' }}
            >
              <Checkbox
                checked={isChecked}
                onClick={() => setIsChecked(!isChecked)}
                style={{ marginRight: 12 }}
              />
              By purchasing an Apeiron Life Membership, you agree to the Apeiron
              Life{' '}
              <Link
                to="/membership-agreement"
                target="_bank"
                style={{
                  textDecoration: 'underline'
                }}
              >
                Membership Agreement
              </Link>
              ,{' '}
              <a
                href="https://apeiron.life/terms-of-use/"
                target="_bank"
                style={{
                  textDecoration: 'underline'
                }}
              >
                Terms of Service{' '}
              </a>
              and{' '}
              <a
                href="https://apeiron.life/privacy-policy/"
                target="_bank"
                style={{
                  textDecoration: 'underline'
                }}
              >
                Privacy Policy{' '}
              </a>
            </div>
            <footer>
              <span className="back">{/* <LeftOutlined /> back */}</span>
              <Button
                type="primary"
                disabled={!confirmAble || confirming}
                className="btn-next"
                onClick={handleConfirm}
              // loading={updating || !!Object.keys(postQueue).length}
              >
                {loading ? 'Initializing...' : 'CONFIRM'}
              </Button>
            </footer>
          </>
        )}
      </div>
    </OnBoardingContainer>
  )

  async function handleConfirm() {
    const params = {
      profile: {
        membership: type,
        billing_preference: billingPreference
      }
    }
    localStorage.setItem('selectedMembership', JSON.stringify(params))
    setConfirming(true)
    await editClient(params, user.id, '?client_select_membership=true')
    _.assign(user.profile, params.profile)
    saveUser(user)
    history.push('/onboarding/ready')
  }

  function handleMembership(value, isOldVersion) {
    if (isOldVersion && !billingPreference) {
      setBillingPreference('annually')
    }
    setType(value)
  }

  function handleBillingPreference(value) {
    setBillingPreference(value)
  }

  // function logOut() {
  //   clearStorage()
  //   logOutAction()
  //   history.push('/sign-in')
  // }
}

const Container = styled.div`
  padding: 60px 205px 80px;
  height: calc(100vh - 230px);
  overflow: auto;
  padding-bottom: 0;
  &.v3 {
    padding: 60px 120px 80px;
    height: auto;
  }
  h1 {
    font-size: 36px;
    line-height: 100%;
    letter-spacing: 0.3px;
    color: #29303e;
  }
  p {
    font-family: Heebo;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.3px;
    color: #5c626a;
    opacity: 0.8;
  }
`

function MemberShip(props) {
  const [price, setPrice] = useState(null)
  const { user, setAmount, paymentMethod, setPaymentMethod } = props
  useEffect(() => {
    const getFees = async () => {
      const result = await getMembershipFees(user.id)
      setPrice(result)
      setAmount(result.filter(item => item.membership === user.profile.membership)[0].price)
      props.setVersion(result[0].version)
    }
    getFees()
  }, [])

  return (
    <MembershipV3
      price={price}
      current={user.profile.membership}
      handleMembership={props.handleMembership}
      handleBillingPreference={props.handleBillingPreference}
      user={user}
      setAmount={setAmount}
      paymentMethod={paymentMethod}
      setPaymentMethod={setPaymentMethod}
    />
  )
}

function MembershipV3(props) {
  const { handleMembership, handleBillingPreference, user, price, setAmount, paymentMethod, setPaymentMethod } = props
  const [current, setCurrent] = useState(props.current)
  const appleMemberships = ['Condition Assessment', 'Fitness Assessment', 'evaluation2']
  const isAppleMembership = appleMemberships.includes(props.current)
  const defaultTab = isAppleMembership ? 'apple' : 'apeiron'
  const [tabKey, setTabKey] = useState(defaultTab)
  const company = user && user.profile && user.profile.company
  const isAppleUser = company === 'Apple - Cupertino'
  const isApeironUser = company === 'Apeiron Life'

  const allTabs = {
    apple: {
      key: 'apple',
      label: company === 'Apollo - New York' ? 'Apollo Memberships' : 'Apple Memberships',
      content: (
        <AppleMembership
          selectable
          onChange={onChange}
          current={current}
          price={price}
        />
      )
    },
    apeiron: {
      key: 'apeiron',
      label: 'Apeiron Memberships',
      content: (
        <ProgramPlan
          selectable
          onChange={onChange}
          current={current}
          price={price}
        />
      )
    }
  }

  const tabsToRender = defaultTab === 'apple'
    ? [allTabs.apple, allTabs.apeiron]
    : [allTabs.apeiron, allTabs.apple]

  return (
    <Container className="v3">
      <h1>Membership Options</h1>
      <p>
        {isApeironUser ? (
          <>
            Please select which program you would like to join. We highly recommend
            the Gold or Silver Membership in order to maximize the benefits of your
            membership, but if you would prefer to start with the assessment and add
            one of our annual membership packages as you learn more about the
            program, you can upgrade at any time. If you have any questions, please
            reach out to{' '}
            <a
              href="mailto:membership@apeiron.life"
              target="_blank"
              style={{
                color: '#0068f2',
                textDecoration: 'underline'
              }}
            >
              membership@apeiron.life
            </a>
            .
          </>
        ) : (
          <>
            Please select the program you would like to join. If you have questions,
            please reach out to{' '}
            <a
              href="mailto:membership@apeiron.life"
              target="_blank"
              style={{
                color: '#0068f2',
                textDecoration: 'underline'
              }}
            >
              membership@apeiron.life
            </a>
            .
          </>
        )}
      </p>

      {/* <div style={{ display: 'flex', alignItems: 'center', gap: 24, margin: '24px 0 0 0' }}>
        {isApeironUser && <BillingSelection {...{ handleBillingPreference, user, plan: current }} />}
        <div>
          <PaymentMethodSelection {...{ setPaymentMethod, paymentMethod }} />
        </div>
      </div>
      <div>* You agree to the Apeiron Life Cancellation policy</div> */}
      {isAppleUser ? (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
          <Tabs
            activeKey={tabKey}
            onChange={setTabKey}
            centered
            tabBarGutter={32}
          >
            {tabsToRender.map(tab => (
              <Tabs.TabPane
                key={tab.key}
                tab={<span style={{ fontSize: 20, fontWeight: 500 }}>{tab.label}</span>}
              >
                {tab.content}
              </Tabs.TabPane>
            ))}
          </Tabs>
        </div>

      ) : (
        <ProgramPlan
          selectable
          onChange={onChange}
          current={current}
          price={price}
        />
      )}
    </Container>
  )

  function onChange(plan) {
    setAmount(price && price.filter(item => item.membership === plan.membership)[0].price)
    handleMembership(plan.membership)
    setCurrent(plan.membership)
  }
}
